import React from "react";

import { Helmet } from "react-helmet";
import Breadcrumb from "../../Component/Breadcrumb";
import { useAuth } from "../../Store/AuthContext";

export default function ReturnPolicy() {
  const { webSetting, Pagemetatags } = useAuth();
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.ReturnPolicy_title}</title>
        <meta
          name="description"
          content={Pagemetatags.ReturnPolicy_description}
        />
        <meta name="keywords" content={Pagemetatags.ReturnPolicy_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename={"Return & Refund Policy"} mainpage="" />

      <section className="Privacysection section-padding pt-3">
        <div className="container">
          <div className="Privacy-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div className="gt-details-content">
                  <div
                    className="gt-list-content mb-0"
                    dangerouslySetInnerHTML={{
                      __html: webSetting.return_policy,
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
